import React, { useState } from "react";
import logo from "@/public/image/logo-nha-nha-khoa-hub.png";
import "./directions-for-use.scss";
import iconCopy from "@/public/icon/icon-copy.png";
import Image from "next/image";
import { Button } from "antd";
import { Modal } from "antd";
import Link from "next/link";
import { usePathname } from "next/navigation";
import Chatbox from "../detail/chatbox";
import iconClose from "@/public/icon/icon-close.png";

export default function DirectionsForUseModal({
  isModalOpen,
  setIsModalOpen,
  type_page,
  detailClinic,
}) {
  const [openChatBox, setOpenChatbox] = useState(false);
  const onBooking = () => {
    setOpenChatbox(true);
    setIsModalOpen(false);
  };
  return (
    <>
      <Modal
        open={isModalOpen}
        width={752}
        className="directions-for-use"
        footer={null}
        centered
        onCancel={() => setIsModalOpen(false)}
      >
        <DirectionsForUse onBooking={onBooking} />
      </Modal>
      <Modal
        className="wpModalChatBox"
        open={openChatBox}
        onCancel={() => {
          setOpenChatbox(false);
        }}
        centered
        footer={null}
        closable={true}
        width={380}
        style={{ top: 20 }}
        destroyOnClose={true}
      >
        <div style={{ position: "relative" }}>
          <Chatbox detailClinic={detailClinic} isModal={true} />
          <div
            className="closeModal"
            onClick={() => {
              setOpenChatbox(false);
            }}
          >
            <Image src={iconClose} alt="Close icon" />
          </div>
        </div>
      </Modal>
    </>
  );
}

const DirectionsForUse = ({ onBooking }) => {
  const pathname = usePathname();
  return (
    <div className="wp-directions-for-use">
      <Image src={logo} alt="logo" className="logo" />
      <div className="title">
        TẶNG NGÀN VOUCHER – NĂM MỚI, RĂNG ĐẸP, SỨC KHỎE TỐT!
      </div>
      <div className="description">
        Nhổ răng khôn: Hoàn ngay 50K
        <br />
        Bọc răng sứ: Nhận lại 100K
        <br />
        Trồng răng: Tiết kiệm thêm 200K
        <br />
         Niềng răng: Hoàn khủng 500K
      </div>
      <div className="coupon-guide">
        <div className="title-guide">HƯỚNG DẪN NHẬN VOUCHER HOÀN TIỀN</div>
        <span className="detail-guide">
          <span style={{ display: "flex" }}>
            <b style={{ textWrap: "nowrap" }}>Bước 1:&nbsp;</b>
            <span style={{ display: "block" }}>
              Đặt lịch tại nha khoa có gắn nhãn khuyến mãi.
            </span>
          </span>
          <div></div>
          <span style={{ display: "flex" }}>
            <b style={{ textWrap: "nowrap" }}>Bước 2:&nbsp;</b>
            <span style={{ display: "block" }}>
              Đến và sử dụng dịch vụ tại nha khoa đã đặt lịch.
            </span>
          </span>
          <div></div>
          <span style={{ display: "flex" }}>
            <b style={{ textWrap: "nowrap" }}>Bước 3:&nbsp;</b>
            <span style={{ display: "block" }}>
              Chụp lại hóa đơn và cung cấp cho NhaKhoaHub để được hoàn tiền theo
              giá trị tuơng ứng.
            </span>
          </span>
          <div></div>
          <span style={{ display: "flex" }}>
            <b style={{ textWrap: "nowrap" }}>LƯU Ý:&nbsp;</b>
            <span style={{ display: "block" }}>
              <b>Quy trình hoàn tiền của NhaKhoaHub </b>
            </span>
          </span>
          <div></div>
          <span>
            - Quý khách vui lòng chụp lại hóa đơn thanh toán đã sử dụng dịch vụ
            tại nha khoa và gửi cho CSKH của NhaKhoaHub.
          </span>
          <div></div>
          <span>
            - NhaKhoaHub sẽ xác nhận lại với cơ sở nha khoa tương ứng và hoàn
            lại giá trị tương ứng với hóa đơn.
          </span>
          <div></div>
          <span>
            - Thời gian hoàn tiền: Trong vòng 15 ngày kể từ ngày nhận được yêu
            cầu hoàn phí theo mã khuyến mãi.
          </span>
        </span>
        <div className="note">
          (Áp dụng cho các nha khoa có gắn nhãn khuyến mãi trên NhaKhoaHub)
        </div>
        <div className="note">(Thời gian áp dụng: 13/02/2025 – 13/03/2025)</div>
      </div>
      {pathname.startsWith("/phong-kham/") ? (
        <Button
          type="primary"
          htmlType="button"
          className="button-submit"
          onClick={onBooking}
        >
          ĐẶT LỊCH NGAY
        </Button>
      ) : (
        <Link href="/phong-kham">
          <Button type="primary" htmlType="button" className="button-submit">
            TÌM NHA KHOA NGAY
          </Button>
        </Link>
      )}
    </div>
  );
};
